module.exports = __webpack_public_path__ + "a0e27f72178c9ea223c25baaf6744c29.pdf";